import type {
  WorkspaceWorkspaceReadModel,
  GroupedWorkspaceConfigModel
} from '@r/api/generated/client.schemas.ts';

type Workspace = WorkspaceWorkspaceReadModel | null | undefined;
type GroupedWorkspaceConfig = GroupedWorkspaceConfigModel | null | undefined;

export const PTS_CONVERSION_TYPES = {
  TYPOLOGY: 'pt-conversion-typology'
} as const;

export type PtsConversionType = (typeof PTS_CONVERSION_TYPES)[keyof typeof PTS_CONVERSION_TYPES];

export const isTargetLogicWorkspace = (workspace?: Workspace): boolean => {
  if (!workspace) {
    return false;
  }

  const type = workspace.currentLogicWorkspace?.logic.type;
  return type === 'TARGET_PERF' || type === 'TARGET_POINT';
};

export const isLinearLogicWorkspace = (workspace?: Workspace): boolean => {
  if (!workspace) {
    return false;
  }

  return workspace.currentLogicWorkspace?.logic.type === 'LINEAR';
};

export const isStepLogicWorkspace = (workspace?: Workspace): boolean => {
  if (!workspace) {
    return false;
  }

  return workspace.currentLogicWorkspace?.logic.type === 'STEP';
};

export const getPtsConversionType = (
  workspaceConfig?: GroupedWorkspaceConfig
): PtsConversionType | null => {
  if (!workspaceConfig) {
    return null;
  }

  return (
    (workspaceConfig.groupedConfigs?.core?.['pts-conversion-type'] as PtsConversionType | null) ??
    null
  );
};

export const isTypologyConversion = (workspaceConfig?: GroupedWorkspaceConfig): boolean => {
  return getPtsConversionType(workspaceConfig) === PTS_CONVERSION_TYPES.TYPOLOGY;
};
